<template>
  <static-fullscreen-card :title="!false" @sendHeight="cardHeight = $event">
    <template v-slot:title>
      <div class="d-flex">
        <v-btn v-if="$vuetify.breakpoint.smAndDown" fab small color="primary lighten-3" @click="showCommentsList = true">
          <v-icon>fas fa-ellipsis-v</v-icon>
        </v-btn>
      </div>
    </template>
    <portal to="v-main"> </portal>
    <ChatRoom />
  </static-fullscreen-card>
</template>

<script>
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";

export default {
  components: {
    Splitpanes,
    Pane,
    baseChats: () => import("./chat3/baseChats.vue"),

    ChatList: () => import("./chat/ChatList"),
  },
  data() {
    return {
      cardHeight: 0,
      selected: null,
      id: 0,
      user_id: this.$root.profile.id || 0,
      targetName: null,
      needUpdateComments: 0,
      commentsList: [],
      idEdit: 0,
      showCommentsList: false,
      title: "",
      loading: false,
      defaults: {
        sort: { key: "id", order: "ASC" },
      },
    };
  },
  created() {
    this.$root.title = "Чат";
    this.fitchData();
     
  },
  computed: {
    target_id() {
      if (!this.selected) return 0;
      return this.commentsList?.[this.selected]?.target_id || 0;
    },
    target_name() {
      if (!this.selected) return null;
      return this.commentsList?.[this.selected]?.target_name || "";
    },
  },
  watch: {
    selected(v) {
      this.id = 0;
      this.$nextTick(() => {
        this.selectGroup(v);
      });
    },
    user_id(v) {
      if (v) this.fitchData();
    },
    showEditDialog() {
      if (!this.showEditDialog) {
        this.$refs.table.updateData();
      }
    },
  },
  methods: {
    selectGroup(m) {
      this.id = this.commentsList?.[m]?.target_id || 0;
      this.targetName = this.commentsList?.[m]?.target_name || "";
    },
    async fitchData() {
      this.loading = true;
      let resp;
      this.commentsList = [];
      let user = this.user_id;
      resp = await this.$axios.get("/mechti/chats");
      this.afterFitch();

      return;
      if (resp.data.data.length > 0) {
        this.commentsList = resp.data.data;
      } else {
        this.afterFitch();
        return;
      }
      this.afterFitch();
      return;
    },
    afterFitch() {
      this.loading = false;
    },
    onClickRow(d) {
      this.showEditDialogFun(d.row.id);
    },
    createNew() {
      this.showEditDialogFun(0);
    },
    showEditDialogFun(id) {
      this.idEdit = id;
      this.showEditDialog = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.splitpanes__pane {
  background-color: inherit !important;
}

.border {
  border-right: 1px solid grey;
}
.chat-window ::v-deep .v-toolbar__content {
  padding: 0 !important;
}
.chat-window {
  position: absolute;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
}
.chat-window__container {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.chat-window__messages {
  flex-grow: 1;
  overflow: auto;
  min-height: 0;
}

// .v-list-item:after {
//   content: unset;
// }
</style>
